/* ============================================================
   KEVENZA — interacciones (vanilla JS, sin librerías)
   ============================================================ */
(function () {
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Reveal on scroll (stagger) ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".kv-reveal");
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("kv-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("kv-visible");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      /* Elements already on screen at load (e.g. the hero) must reveal right
         away — otherwise above-the-fold content stays blank until the first
         scroll. Only defer the ones below the fold to the scroll observer. */
      var rect = el.getBoundingClientRect();
      if (rect.top < vh && rect.bottom > 0) {
        el.classList.add("kv-visible");
      } else {
        io.observe(el);
      }
    });
  }

  /* ---------- Count-up numbers ---------- */
  function initCounters() {
    var nums = document.querySelectorAll("[data-kv-count]");
    if (!nums.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      nums.forEach(function (n) { n.textContent = format(n, parseFloat(n.getAttribute("data-kv-count"))); });
      return;
    }
    function format(el, val) {
      var dec = parseInt(el.getAttribute("data-kv-decimals") || "0", 10);
      var s = dec > 0 ? val.toFixed(dec) : Math.round(val).toLocaleString("en-US");
      return (el.getAttribute("data-kv-prefix") || "") + s + (el.getAttribute("data-kv-suffix") || "");
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute("data-kv-count"));
        var dur = 1600, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = format(el, target * eased);
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = format(el, target);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------- Marquee: duplicate track for seamless loop ---------- */
  function initMarquee() {
    var tracks = document.querySelectorAll(".kv-marquee__track");
    tracks.forEach(function (track) {
      if (track.getAttribute("data-kv-cloned")) return;
      var kids = Array.prototype.slice.call(track.children);
      kids.forEach(function (k) { track.appendChild(k.cloneNode(true)); });
      track.setAttribute("data-kv-cloned", "1");
    });
  }

  /* ---------- Parallax (subtle, transform only) ---------- */
  function initParallax() {
    if (reduce) return;
    var items = document.querySelectorAll("[data-kv-parallax]");
    if (!items.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var speed = parseFloat(el.getAttribute("data-kv-parallax")) || 0.15;
        var offset = (rect.top + rect.height / 2 - vh / 2) * -speed;
        el.style.transform = "translate3d(0," + offset.toFixed(1) + "px,0)";
      });
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var gallery = document.querySelector("[data-kv-gallery]");
    if (!gallery) return;
    var mainImg = gallery.querySelector("[data-kv-main]");
    var thumbs = gallery.querySelectorAll("[data-kv-thumb]");
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var full = t.getAttribute("data-full");
        if (full && mainImg) {
          mainImg.style.opacity = "0";
          setTimeout(function () {
            mainImg.src = full;
            mainImg.style.opacity = "1";
          }, 160);
        }
        thumbs.forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });
  }

  /* ---------- Product variants ---------- */
  function initVariants() {
    var form = document.querySelector("[data-kv-product-form]");
    if (!form) return;
    var dataEl = document.querySelector("[data-kv-variants]");
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector("[data-kv-add]");
    var priceNow = document.querySelector("[data-kv-price-now]");
    var priceWas = document.querySelector("[data-kv-price-was]");
    var selected = {};

    var groups = form.querySelectorAll("[data-kv-option]");
    groups.forEach(function (group) {
      var name = group.getAttribute("data-kv-option");
      var active = group.querySelector(".kv-swatch.is-active");
      if (active) selected[name] = active.getAttribute("data-value");
      group.querySelectorAll(".kv-swatch").forEach(function (sw) {
        sw.addEventListener("click", function () {
          group.querySelectorAll(".kv-swatch").forEach(function (x) { x.classList.remove("is-active"); });
          sw.classList.add("is-active");
          selected[name] = sw.getAttribute("data-value");
          updateVariant();
        });
      });
    });

    function updateVariant() {
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected[v.optionNames[i]] === opt;
        });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceNow) priceNow.textContent = match.price_money;
      if (priceWas) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceWas.textContent = match.compare_money;
          priceWas.style.display = "";
        } else {
          priceWas.style.display = "none";
        }
      }
      if (addBtn) {
        if (match.available) {
          addBtn.removeAttribute("disabled");
          addBtn.textContent = addBtn.getAttribute("data-label") || "Add to cart";
        } else {
          addBtn.setAttribute("disabled", "disabled");
          addBtn.textContent = "Sold out";
        }
      }
    }
    updateVariant();
  }

  /* ---------- Cart: use Dawn's cart drawer if present ---------- */
  function initCart() {
    var form = document.querySelector("[data-kv-product-form]");
    if (!form) return;
    form.addEventListener("submit", function (e) {
      var drawer = document.querySelector("cart-drawer");
      if (!drawer) return; /* let it submit normally to /cart */
      e.preventDefault();
      var btn = form.querySelector("[data-kv-add]");
      if (btn) { btn.setAttribute("aria-busy", "true"); }
      var formData = new FormData(form);
      formData.append("sections", "cart-drawer,cart-icon-bubble");
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
        method: "POST",
        headers: { "Accept": "application/javascript" },
        body: formData
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (btn) btn.removeAttribute("aria-busy");
        if (res.sections) {
          try {
            drawer.renderContents(res);
          } catch (err) {
            document.querySelectorAll("cart-drawer").forEach(function (d) { d.classList.remove("is-empty"); });
          }
        }
        if (drawer.open) drawer.open();
        else if (typeof drawer.setActiveElement === "function") drawer.open();
      }).catch(function () {
        if (btn) btn.removeAttribute("aria-busy");
        form.submit();
      });
    });
  }

  /* ---------- Before/After compare slider ---------- */
  function initCompare() {
    var boxes = document.querySelectorAll("[data-kv-compare]");
    boxes.forEach(function (box) {
      var dragging = false;
      function setPos(clientX) {
        var rect = box.getBoundingClientRect();
        if (!rect.width) return;
        var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
        box.style.setProperty("--pos", ((x / rect.width) * 100).toFixed(2) + "%");
      }
      function down(e) {
        dragging = true;
        box.classList.add("is-dragging");
        if (box.setPointerCapture && e.pointerId != null) {
          try { box.setPointerCapture(e.pointerId); } catch (err) {}
        }
        setPos(e.clientX);
      }
      function move(e) { if (dragging) setPos(e.clientX); }
      function up() { dragging = false; box.classList.remove("is-dragging"); }
      if (window.PointerEvent) {
        box.addEventListener("pointerdown", down);
        box.addEventListener("pointermove", move);
        box.addEventListener("pointerup", up);
        box.addEventListener("pointercancel", up);
      } else {
        box.addEventListener("mousedown", down);
        window.addEventListener("mousemove", move);
        window.addEventListener("mouseup", up);
      }
    });
  }

  /* ---------- Bundle / pack selector (sets quantity + price) ---------- */
  function initBundle() {
    var wrap = document.querySelector("[data-kv-bundle]");
    if (!wrap) return;
    var cards = wrap.querySelectorAll("[data-kv-pack]");
    if (!cards.length) return;
    var qtyInput = document.querySelector("[data-kv-qty]");
    var priceNow = document.querySelector("[data-kv-price-now]");
    var priceWas = document.querySelector("[data-kv-price-was]");
    function select(card) {
      cards.forEach(function (c) { c.classList.remove("is-active"); c.setAttribute("aria-pressed", "false"); });
      card.classList.add("is-active");
      card.setAttribute("aria-pressed", "true");
      var qty = parseInt(card.getAttribute("data-qty"), 10) || 1;
      if (qtyInput) qtyInput.value = qty;
      var price = card.getAttribute("data-price");
      var compare = card.getAttribute("data-compare");
      if (priceNow && price) priceNow.textContent = price;
      if (priceWas) {
        if (compare) { priceWas.textContent = compare; priceWas.style.display = ""; }
        else { priceWas.style.display = "none"; }
      }
      /* keep the sticky bar in sync if present */
      var sBar = document.querySelector("[data-kv-sticky-price]");
      if (sBar && price) sBar.textContent = price;
    }
    cards.forEach(function (card) {
      card.addEventListener("click", function () { select(card); });
    });
    var initial = wrap.querySelector("[data-kv-pack].is-active") || cards[0];
    if (initial) select(initial);
  }

  /* ---------- Sticky add-to-cart bar (mobile-first) ---------- */
  function initStickyBar() {
    var bar = document.querySelector("[data-kv-stickybar]");
    var form = document.querySelector("[data-kv-product-form]");
    if (!bar || !form) return;
    var addBtn = form.querySelector("[data-kv-add]");
    var stickyBtn = bar.querySelector("[data-kv-sticky-add]");
    if (stickyBtn && addBtn) {
      stickyBtn.addEventListener("click", function () { addBtn.click(); });
    }
    /* show the bar once the main buy button scrolls out of view */
    if ("IntersectionObserver" in window && addBtn) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle("is-visible", !e.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(addBtn);
    }
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () {
    initReveal();
    initCounters();
    initMarquee();
    initParallax();
    initGallery();
    initVariants();
    initBundle();
    initCart();
    initStickyBar();
    initCompare();
  });
})();
